var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"11.403","x2":"26.715","y2":"11.403","stroke":"black","strokewidth":"2","x1":"-0.285","transform":"matrix(0.707107, 0.707107, -0.707107, 0.707107, 11.933722, -6.004555)","style":{"strokeWidth":"1.5px"},"key":0}),React.createElement("line",{"y1":"11.597","x2":"27.285","y2":"11.597","stroke":"black","strokewidth":"2","x1":"0.285","transform":"matrix(0.707107, -0.707107, 0.707107, 0.707107, -4.162784, 13.14415)","style":{"strokeWidth":"1.5px"},"key":1})]);
}

MenuClose.defaultProps = {"width":"27","height":"24px","viewBox":"0 0 27 24","fill":"none"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
